import {xhrWithTimeout} from "./xhrWithTimeout";
import isEmpty from 'lodash/isEmpty';

export const fileUpload = (url, file, onProgress) => {
    const body = new FormData();
    body.append('attachment', file);

    const port = isEmpty(window.location.port) ? '' : `:${window.location.port}`;
    let urlObj = new URL(`${window.location.protocol}//${window.location.hostname}${port}${url}`);
    const replaceHostname = urlObj.hostname.match(/^.+?\.(\w+\.[a-z]+)$/i);
    if (replaceHostname && replaceHostname[1]) {
        urlObj = new URL(`${urlObj.protocol}//upload.${replaceHostname[1]}${port}${urlObj.pathname}${urlObj.search}`);
    }

    return xhrWithTimeout(urlObj.toString(), {
        method: 'post',
        body
    }, onProgress);
}